import {DAVKY_DTM_URL, DTM_DETAIL_URL, MAPA_URL} from '../const/UrlDefinitions';
import {DtmTabs} from '../enums/DtmTabs';
import {useAppConfig} from '@mc/react-app-base';
import {MapioDtmControllerApiAxiosParamCreator} from '../api/gen';

/**
 * NASLEDUJICI URL JSOU JEN PRO INTERNI REZIM
 */

export const getMapaUrl = () => {
    return MAPA_URL;
};

export const getDavkyDtmUrl = () => {
    return DAVKY_DTM_URL;
};

export const getDtmDetailUrl = (id: number, tab?: DtmTabs) => {
    return DTM_DETAIL_URL.replace(':id', `${id}`).replace(':tab', `${tab ?? DtmTabs.HOME}`);
};

/**
 * Z DUVODU JEDNODUSI ORIENTACE DEFINICE S PARAMCREATORAMA DAVAME SEPARATNE
 */

let prenosSouborTeml;
export const preFetchtUrls = async () => {
    // do teto metody patri vsechny volani, ktere se maji provest pri nacteni aplikace
    // tj. cokoliv s ParamCreatorama, ktere jsou asynchroni
    const {url: prenosSouborUrl} = await MapioDtmControllerApiAxiosParamCreator().getPrenosSoubor(-666);
    prenosSouborTeml = prenosSouborUrl;
};

export const getPrenosSouborUrl = (idDokumentu: number): string => {
    const config = useAppConfig();
    return config.serverContextPath + prenosSouborTeml.replace(-666, idDokumentu);
};
